import { RootState } from '../combinedReducers'

export const timedOutSelector = (state: RootState) => state.timer.timedOut

export const timerRemainingSecondsSelector = (state: RootState) =>
  state.timer.remainingSeconds

export const isRunningSelector = (state: RootState) => state.timer.isRunning
